// Export enum MediaQuery.
export enum MediaQuery {
  mobile = '@media only screen and (max-width: 767px)',
  fromTabletUp = '@media only screen and (min-width: 768px)',
  lessThanOrEqualToTablet = '@media only screen and (max-width: 1023px)',
  fromDesktopUp = '@media only screen and (min-width: 1024px)',
}
